export const chartTypes = {
  NUMBER_OF_WINS: "numberOfWins",
  AVG_KILLS: "avgKills",
  AVG_DAMAGE_DELT: "avgDamageDealt",
  AVG_RANK: "avgRank",
  AVG_TIME_SURVIVED: "avgTimeSurvived",
  AVG_DAMAGE_TAKEN: "avgDamageTaken",
};
